import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import config from './2-images-with-copy.config';
import { IPageComponent2ImagesWithCopyData } from './2-images-with-copy.interface';

@Component({
    selector: 'page-component-2-images-with-copy',
    templateUrl: './2-images-with-copy.html',
    standalone: true,
    imports: [DfImageDirective, HrefComponent, ICmsClientModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponent2ImagesWithCopyComponent>(config)
export class PageComponent2ImagesWithCopyComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponent2ImagesWithCopyData;
}
